import type { IMemberPaperResponse } from "@api/members/papers";
import type { IJournalPaperTable } from "@/template/articlesAndBooks/journalPaper/table";

export function journalPaperTableMapper(
  data: IMemberPaperResponse,
): IJournalPaperTable {
  return {
    id: data?.id,
    authors: data?.authors?.split(",")?.map((author) => author?.trim()),
    journalName: data?.publisher,
    paperName: data?.title,
    publishYear: data?.publication_date,
    isApproved: data?.is_approved,
  };
}
